import { ActionTree } from 'vuex';
import ApiUrl from '../../../api/url';
import { ProductVersionState } from './types';
import { RootState } from '../../types';
import * as types from './mutation-types';
import { isHappenedOtherPartyError } from '../../error-type';

export const actions: ActionTree<ProductVersionState, RootState> = {
    /**
     * 製品バージョン取得
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async index({ dispatch, commit }) {
        try {
            commit(types.INDEX_START);
            const resData = await dispatch(
                'auth/api',
                { method: 'get', url: ApiUrl.ProductVersion.INDEX },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.INDEX_SUCCESS, resData);
            }
        } catch (resData) {
            // アプリケーションエラー時
            const params = {
                errorTitle: resData.title,
                errorDetails: resData.errors,
            };
            commit(types.INDEX_FAILURE, params);
        }
    },

    /**
     * 画面切り替え時のstoreの消去
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async clearOnBeforeRoute({ commit }) {
        /* 消す必要がない */
    },
};
